import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueHierarchyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-hierarchy-view',
	path: '/jira/settings/issues/issue-hierarchy',
};
